import React, { useState } from 'react';
// import Navbar from '../../../Components/share/navbar/Navbar';
import Sorting from '../../../Components/layouts/bootcamps/Sorting';
import BootCampSearch from '../../../Components/share/search/BootCampSearch';
import Card from '../../../Components/share/cards/Card';
import design from '../../../Assets/Image/svg/design.svg';
import managing from '../../../Assets/Image/svg/managing.svg';
import marketing from '../../../Assets/Image/svg/marketing.svg';
import programming from '../../../Assets/Image/svg/programming.svg';
import selfdevelope from '../../../Assets/Image/svg/selfdevelope.svg';
import startup from '../../../Assets/Image/svg/startup.svg';
import CardInfo from '../../../Components/layouts/bootcamps/CardInfo';
import Pageination from '../../../Components/share/Pageination/Pageination';
import AdminPagination from '../../../Components/share/Pageination/AdminPagination';

const bootCmapInfos = [
	{ img: managing, title: 'مدیریت' },
	{ img: startup, title: 'استارتاپ' },
	{ img: design, title: 'طراحی' },
	{ img: programming, title: 'برنامه نویسی' },
	{ img: marketing, title: 'مارکتینگ' },
	{ img: selfdevelope, title: 'توسعه فردی' },
];

function BootCamps() {
	const [num, setNum] = useState();
	const [show, setShow] = useState(true);

	const handleCardInfo = (i) => {
		setNum(i);
		setShow((prev) => !prev);
	};
	const [count, setCount] = useState(false);
	const pageSize = Array.from(Array(10).keys());
	// pageSize.indexOf();

	return (
		<div className='pb-[2.3rem] pt-12'>
			{show ? (
				<div className='container-primary'>
					{/* <Navbar /> */}
					<div className='flex flex-col items-center mb-[3.9rem]'>
						<h1 className='text-20 text-black-prim leading-extra-loose'>
							برگزارکننده یا شرکت‌کننده؟ انتخاب با شماست!
						</h1>
						<p className='text-cd text-black-prim leading-extra-loose'>
							حوزه مورد علاقه‌ی خود را جستجو کنید و بی‌درنگ در یکی از
							وبینارهای بوت‌وب شرکت کنید
						</p>
					</div>
					<BootCampSearch className='mb-[7.3rem]' />
					{/* cards */}
					<div className='grid-cols-6 grid gap-[4rem] mb-[3rem] bootcamp__info'>
						{bootCmapInfos.map((bootcampinfo, key) => {
							return [
								<Card
									key={key}
									className='flex items-center justify-center flex-col py-[2rem] transition-all duration-300 hover:bg-light-prim2 '
								>
									<img src={bootcampinfo.img} className='mb-[1rem]' />
									<h2 className='text-black-prim text-sm'>
										{bootcampinfo.title}
									</h2>
								</Card>,
							];
						})}
					</div>
					{/* end-cards */}
					{/* search result */}
					<div className='flex items-center mb-[3rem]'>
						<span className='text-light-prim text-cd leading-extra-loose ml-[2rem]'>
							منظور شما این است:
						</span>
						<em className='text-cd text-black not-italic'>
							{' '}
							آموزش بازاریابی
						</em>
					</div>

					{/* end-search-result */}
					<Sorting onclick={handleCardInfo} />
					{count == true ? <Pageination pageSize={10} /> : ''}
				</div>
			) : (
				<CardInfo />
			)}
		</div>
	);
}
export default BootCamps;
